import React from "react"
import Layout from "../components/layout"
import MetaTags from "../components/metaTags"

import City from "../components/bodies/city"
import County from "../components/bodies/county"
import Locations from "../components/bodies/locations"
import Zip from "../components/bodies/zip"
import States from "../components/bodies/states"


function Page(data) {

  const bodies = {
    city: City,
    county: County,
    locations: Locations,
    zip: Zip,
    states: States
  }

  const BodyControl = bodies[data.pageContext.bodyControl]

  const isLocationTemplate = (data.pageContext.bodyControl === "locations")

  const title = (isLocationTemplate) ? `CommUSA Locations` :
    `Best Two-Way Radios for Sale & Rent in ${data.pageContext.area_name}`

  const description = (isLocationTemplate) ? `Find a CommUSA location near you. CommUSA is North America’s most knowledgeable Motorola Dealer with price match guarantee. Our consultants will help you pick the right product and solution for your needs!` :
    `Buy and rent two-way radios in ${data.pageContext.area_name}. CommUSA is North America’s most knowledgeable Motorola Dealer with price match guarantee. Our consultants will help you pick the right product and solution for your needs!`

  const shareDesc = (isLocationTemplate) ? `Find a CommUSA location near you.`:
    `Buy and rent two-way radios in ${data.pageContext.area_name}.`

  const index = (data.pageContext.bodyControl === 'zip') ? `noindex`: `index`

  return (
    <Layout>
      <MetaTags
        data={data.pageContext}
        lang='en'
        locale='en-us'
        href={data.location.href}
        path={data.path}
        lang_path={data.pageContext.lang_path}
        metaIndex={index}

        title={`${title} | CommUSA`}
        description={description}

        share_image='https://www.commusa.com/locations/images/commusa-featured.jpg'
        share_image_alt="CommUSA - A Charter Motorola Two-Way Radio Dealership"
        share_image_width="1200"
        share_image_height="630"

        og_locale="en_US"
        site_name={`CommUSA`}
        share_title={`CommUSA`}
        share_description={shareDesc}

        twitter_card="summary_large_image"
        twitter_title={`CommUSA`}
        twitter_description={shareDesc}
        twitter_image="https://www.commusa.com/locations/images/commusa-featured.jpg"

      />
      <BodyControl data={data.pageContext}/>
    </Layout>
  )
}

export default Page
